const dataGridPageSizeOptions = [5, 10, 20, 50] as const;

export default dataGridPageSizeOptions;
